import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react'; // Or another icon like AlertTriangle, Zap, ShieldCheck
import { Modal, ModalProps } from './ui/Modal'; // Assuming Modal.tsx is in ./ui/
import { Button } from './ui/Button';
import { useFeatureUpgradeModal } from '../contexts/FeatureUpgradeModalContext'; // Adjust path if needed

// Define translation keys for the modal's static content
const MODAL_TITLE_KEY = 'featureUpgradeModal.title';
const MODAL_CONTACT_PROMPT_KEY = 'featureUpgradeModal.contactPrompt';
const MODAL_CONTACT_EMAIL = 'hello@praxi.hu'; // Your support email
const MODAL_CONTACT_CTA_KEY = 'featureUpgradeModal.contactCTA';
const MODAL_CLOSE_BUTTON_KEY = 'featureUpgradeModal.closeButton';

export const FeatureUpgradeModal: React.FC = () => {
  const { t } = useTranslation();
  const { isUpgradeModalOpen, modalContent, closeUpgradeModal } = useFeatureUpgradeModal();

  if (!isUpgradeModalOpen || !modalContent) {
    return null;
  }

  const { featureNameKey, customMessageKey, customMessageOptions } = modalContent;

  const modalTitle = t(featureNameKey) // Use the specific feature name as part of the title or a generic title
    ? `${t('featureUpgradeModal.unlockFeatureTitlePrefix')} ${t(featureNameKey)}`
    : t(MODAL_TITLE_KEY);

  return (
    <Modal
      isOpen={isUpgradeModalOpen}
      onClose={closeUpgradeModal}
      title={modalTitle}
      size="md" // Adjust size as needed
      footer={
        <Button onClick={closeUpgradeModal} variant="primary">
          {t(MODAL_CLOSE_BUTTON_KEY)}
        </Button>
      }
    >
      <div className="text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 bg-indigo-100 rounded-full mb-6">
          <Lock className="h-8 w-8 text-indigo-600" />
        </div>
        <p className="text-lg text-gray-700 mb-4">
          {t(customMessageKey, customMessageOptions)}
        </p>
        <p className="text-md text-gray-500">
          {t(MODAL_CONTACT_PROMPT_KEY)}{' '}
          <a
            href={`mailto:${MODAL_CONTACT_EMAIL}`}
            className="font-medium text-indigo-600 hover:text-indigo-500"
          >
            {MODAL_CONTACT_EMAIL}
          </a>{' '}
          {t(MODAL_CONTACT_CTA_KEY)}
        </p>
      </div>
    </Modal>
  );
}; 